export default "__VITE_ASSET__UvkNyFHT__"